import { withTranslation } from "react-i18next";
import OrderTourItemDetail from './OrderTourItemDetail';

export default withTranslation()(OrderTourItemDetail);